<template>
  <tr class="add-row">
    <td></td>
    <td>
      <div class="add-row-buttons">
        <div class="main-button orange no-background sm" @click="save">
          Save
        </div>
        <div class="main-button no-background sm" @click="cancel">Cancel</div>
      </div>
    </td>
    <td>
      <div class="table-cell" :style="setWidthColumn(getColumn('id'))">
        {{ rowData?.id }}
      </div>
    </td>
    <td>
      <div class="table-cell" :style="setWidthColumn(getColumn('url'))">
        <input-text v-model="url" />
      </div>
    </td>
    <td>
      <div class="table-cell" :style="setWidthColumn(getColumn('anchor'))">
        <input-text v-model="anchor" />
      </div>
    </td>
    <td>
      <div class="table-cell" :style="setWidthColumn(getColumn('target_page'))">
        <input-text v-model="target_page" />
      </div>
    </td>
    <td>
      <div class="table-cell" :style="setWidthColumn(getColumn('status'))">
        <input-select v-model="status" />
      </div>
    </td>
    <!-- <td>
      <div
        class="table-cell"
        :style="setWidthColumn(getColumn('slack_community_status'))"
      >
        <input-select v-model="slack_community_status" />
      </div>
    </td> -->
    <td>
      <div
        class="table-cell"
        :style="setWidthColumn(getColumn('slack_community'))"
      >
        <input-select v-model="slack_community" />
      </div>
    </td>
    <td>
      <div class="table-cell" :style="setWidthColumn(getColumn('loss_reason'))">
        <input-select v-model="loss_reason" />
      </div>
    </td>
    <td>
      <div
        class="table-cell"
        :style="setWidthColumn(getColumn('date_requested'))"
      >
        {{ rowData?.date_requested }}
      </div>
    </td>
    <td>
      <div
        class="table-cell"
        :style="setWidthColumn(getColumn('date_published'))"
      >
        <input-date-picker v-model="date_published" />
      </div>
    </td>
    <td>
      <div class="table-cell" :style="setWidthColumn(getColumn('p2p'))">
        <input-select v-model="p2p" />
      </div>
    </td>
    <td>
      <div
        class="table-cell"
        :style="setWidthColumn(getColumn('commercial_pages_link'))"
      >
        <input-select v-model="commercial_pages_link" />
      </div>
    </td>
    <td>
      <div class="table-cell" :style="setWidthColumn(getColumn('comments'))">
        <input-text v-model="comments" />
      </div>
    </td>
    <td>
      <div class="table-cell" :style="setWidthColumn(getColumn('cost'))">
        <input-number v-model="cost" />
      </div>
    </td>
    <td>
      <div class="table-cell" :style="setWidthColumn(getColumn('dr'))">
        {{ rowData?.dr }}
      </div>
    </td>
    <td>
      <div
        class="table-cell"
        :style="setWidthColumn(getColumn('date_status_changed'))"
      >
        {{ rowData?.date_status_changed }}
      </div>
    </td>
    <td>
      <div class="table-cell" :style="setWidthColumn(getColumn('rescued'))">
        <div class="checkbox-row checked" v-if="rowData?.rescued">
          <svg
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="0.5" y="0.5" width="13" height="13" rx="2.5"></rect>
            <path
              d="M4 7L6 9L10 5"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </div>
        <div class="checkbox-row" v-else>
          <svg
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="0.5" y="0.5" width="13" height="13" rx="2.5"></rect>
          </svg>
        </div>
      </div>
    </td>
    <td>
      <div
        class="table-cell"
        :style="setWidthColumn(getColumn('date_created'))"
      >
        {{ rowData?.date_created }}
      </div>
    </td>
    <td>
      <div class="table-cell" :style="setWidthColumn(getColumn('client_id'))">
        <input-select v-model="client_id" />
      </div>
    </td>
    <td>
      <div
        class="table-cell"
        :style="setWidthColumn(getColumn('parser_status'))"
      >
        {{ rowData?.parser_status }}
      </div>
    </td>

    <td></td>
    <td></td>
  </tr>
  <alert-yes-no
    v-if="isVisibleConfirmAlert"
    title="Error"
    :text="textConfirmAlert"
    :alertResult="alertConfirmResult"
    :hideYes="false"
    :hideNo="true"
  />
</template>

<script>
import { inject, shallowRef } from 'vue'
import InputDatePicker from '@/components/inputs/InputDatePicker'
import InputSelect from '@/components/inputs/InputSelect'
import InputNumber from '@/components/inputs/InputNumber'
import { fetchData, urls } from '@/utils/urls.js'
import { newRowMixin } from '@/utils/new-row-mixin'

export default {
  name: 'NewRowPartnerLinksFromPartner',
  mixins: [newRowMixin],
  components: { InputDatePicker, InputSelect, InputNumber },

  data() {
    let regExpUrl =
      /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,10}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/

    return {
      partner_id: shallowRef(inject('partner_id')).value,

      client_name: {
        value: null,
        isValid: true,
        required: false,
        readonly: false,
      },

      client_id: {
        value: [], // Выбранные значения. Если ничего не выбрано передавать пустой массив
        isValid: false, // Валидно ли поле
        clearable: true, // Показывает значок очистки
        required: false, // Обязательность
        readonly: false, // Редактируемость
        isMultiselect: false, // Возможность множественного выбора
        isTags: false, // Показывать в виде тегов
        isLiveSearch: true, // Показывать возможность фильтрации по строке
        dataList: [
          // Данные для выпадающего списка
        ],
        class: 'sm',
      },

      url: {
        value: null,
        isValid: false,
        clearable: true,
        required: true,
        readonly: false,
        errorKey: '',
        class: 'sm',
        regexp: regExpUrl,
      },
      anchor: {
        value: null,
        isValid: false,
        clearable: true,
        required: true,
        readonly: false,
        errorKey: '',
        class: 'sm',
      },

      commercial_pages_link: {
        value: [], // Выбранные значения. Если ничего не выбрано передавать пустой массив
        isValid: false, // Валидно ли поле
        clearable: true, // Показывает значок очистки
        required: true, // Обязательность
        readonly: false, // Редактируемость
        isMultiselect: false, // Возможность множественного выбора
        isTags: false, // Показывать в виде тегов
        isLiveSearch: true, // Показывать возможность фильтрации по строке
        dataList: [
          // Данные для выпадающего списка
          {
            id: 'Yes',
            name: 'Yes',
          },
          {
            id: 'No',
            name: 'No',
          },
          // {
          //   id: 'Maybe',
          //   name: 'Maybe',
          // },
        ],
        class: 'sm',
      },

      comments: {
        value: null,
        isValid: true,
        clearable: true,
        required: false,
        readonly: false,
        errorKey: '',
        class: 'sm',
      },

      /* target_page: {
                value: [], // Выбранные значения. Если ничего не выбрано передавать пустой массив
                isValid: false, // Валидно ли поле
                clearable: true, // Показывает значок очистки
                required: false, // Обязательность
                readonly: false, // Редактируемость
                isMultiselect: false, // Возможность множественного выбора 
                isTags: false, // Показывать в виде тегов
                isLiveSearch: true, // Показывать возможность фильтрации по строке
                dataList: [ // Данные для выпадающего списка
                ],
                class: 'sm'
            },*/

      target_page: {
        value: null,
        isValid: false,
        clearable: true,
        required: true,
        readonly: false,
        errorKey: '',
        class: 'sm',
        regexp: regExpUrl,
      },

      /*date_requested: {
                value: null,
                isValid: false,
                clearable: true,
                required: false,
                readonly: false,
                errorKey: '',
                class: 'sm'
            },*/

      date_published: {
        value: null,
        isValid: false,
        clearable: true,
        required: true,
        readonly: false,
        errorKey: '',
        class: 'sm',
      },

      cost: {
        value: null,
        isValid: true,
        clearable: true,
        required: false,
        readonly: false,
        errorKey: '',
        class: 'sm',
      },

      status: {
        value: [], // Выбранные значения. Если ничего не выбрано передавать пустой массив
        isValid: false, // Валидно ли поле
        clearable: true, // Показывает значок очистки
        required: false, // Обязательность
        readonly: false, // Редактируемость
        isMultiselect: false, // Возможность множественного выбора
        isTags: false, // Показывать в виде тегов
        isLiveSearch: true, // Показывать возможность фильтрации по строке
        dataList: [
          // Данные для выпадающего списка
        ],
        class: 'sm',
      },

      loss_reason: {
        value: [], // Выбранные значения. Если ничего не выбрано передавать пустой массив
        isValid: false, // Валидно ли поле
        clearable: true, // Показывает значок очистки
        required: false, // Обязательность
        readonly: false, // Редактируемость
        isMultiselect: false, // Возможность множественного выбора
        isTags: false, // Показывать в виде тегов
        isLiveSearch: true, // Показывать возможность фильтрации по строке
        dataList: [
          // Данные для выпадающего списка
        ],
        class: 'sm',
      },

      p2p: {
        value: [], // Выбранные значения. Если ничего не выбрано передавать пустой массив
        isValid: false, // Валидно ли поле
        clearable: true, // Показывает значок очистки
        required: true, // Обязательность
        readonly: false, // Редактируемость
        isMultiselect: false, // Возможность множественного выбора
        isTags: false, // Показывать в виде тегов
        isLiveSearch: false, // Показывать возможность фильтрации по строке
        dataList: [
          { id: 'Yes', name: 'Yes' },
          { id: 'No', name: 'No' }, // Данные для выпадающего списка
        ],
        class: 'sm',
      },

      // slack_community_status: {
      //   value: [], // Выбранные значения. Если ничего не выбрано передавать пустой массив
      //   isValid: true, // Валидно ли поле
      //   clearable: true, // Показывает значок очистки
      //   required: false, // Обязательность
      //   readonly: false, // Редактируемость
      //   isMultiselect: false, // Возможность множественного выбора
      //   isTags: false, // Показывать в виде тегов
      //   isLiveSearch: true, // Показывать возможность фильтрации по строке
      //   dataList: [
      //     // Данные для выпадающего списка
      //   ],
      //   class: 'sm',
      // },

      slack_community: {
        value: [], // Выбранные значения. Если ничего не выбрано передавать пустой массив
        isValid: true, // Валидно ли поле
        clearable: false, // Показывает значок очистки
        required: false, // Обязательность
        readonly: false, // Редактируемость
        isMultiselect: false, // Возможность множественного выбора
        isTags: false, // Показывать в виде тегов
        isLiveSearch: true, // Показывать возможность фильтрации по строке
        dataList: [
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ],
        class: 'sm',
      },
    }
  },

  async created() {
    await this.fetchDataLinkStatus()
    await this.fetchDataClients()
    //await this.fetchDataSlackCommunityStatus()
    this.fetchDataLinkReason()
    //await this.fetchDataTarget_page()
    for (let key in this.rowData) {
      const element = this.rowData[key]
      if (key in this.$data) {
        if (element && typeof element === 'object' && element.length)
          this.$data[key].value = element
        else if (!element && element !== false) continue
        else if (key === 'status') this.$data[key].value = [element]
        else if (key === 'slack_community_status')
          this.$data[key].value = [element]
        else if (key === 'slack_community')
          this.$data[key].value = [element]
        else if (key === 'commercial_pages_link')
          this.$data[key].value = [element]
        else if (key === 'loss_reason') this.$data[key].value = [element]
        else if (key === 'p2p') this.$data[key].value = [element]
        else if (key === 'client_id') {
          this.$data['client_id'].value = [element]
        } else this.$data[key].value = element

        if (element || element === 0 || element === false)
          this.$data[key].isValid = true
      }
    }

    if (
      this.status.value &&
      (this.status.value.includes('Declined') ||
        this.status.value.includes('Recalled') ||
        this.status.value.includes('Failed'))
    ) {
      this.comments.required = true
      if (!this.comments.value) this.comments.isValid = false
    } else {
      this.comments.required = false
      this.comments.isValid = true
    }

    if (
      this.status.value &&
      (this.status.value.includes('Declined') ||
        this.status.value.includes('Failed'))
    ) {
      this.loss_reason.required = true
      this.loss_reason.readonly = false
      this.loss_reason.isValid = this.loss_reason.value?.length ? true : false
    } else {
      this.loss_reason.required = false
      this.loss_reason.readonly = true
      this.loss_reason.isValid = true
    }

    if (this.status.value && this.status.value.includes('Undefined')) {
      this.commercial_pages_link.isValid = true
      this.commercial_pages_link.required = false
    } else {
      this.commercial_pages_link.isValid =
        this.commercial_pages_link.value &&
        this.commercial_pages_link.value.length
          ? true
          : false
      this.commercial_pages_link.required = true
    }

    if (!this.p2p.value || !this.p2p.value.length) {
      this.cost.required = true
      this.cost.isValid = this.cost.value ? true : false

      this.p2p.required = true
      this.p2p.isValid = false
    } else if (this.p2p.value[0] === 'Yes') {
      this.cost.required = false
      this.cost.isValid = true
    } else if (this.p2p.value[0] === 'No') {
      this.cost.required = true
      this.cost.isValid = this.cost.value ? true : false
    }
  },

  computed: {
    isValid() {
      for (const key in this.$data) {
        let entityValue = this.$data[key]
        if (
          typeof entityValue === 'object' &&
          'isValid' in entityValue &&
          !entityValue.isValid
        )
          return false
      }

      return true
    },
  },

  watch: {
    'p2p.value': {
      deep: true,
      handler() {
        if (!this.p2p.value || !this.p2p.value.length) {
          this.cost.required = true
          this.cost.isValid = this.cost.value ? true : false

          this.p2p.required = true
          this.p2p.isValid = false
        } else if (this.p2p.value[0] === 'Yes') {
          this.cost.required = false
          this.cost.isValid = true
        } else if (this.p2p.value[0] === 'No') {
          this.cost.required = true
          this.cost.isValid = this.cost.value ? true : false
        }
      },
    },

    'status.value': {
      deep: true,
      handler() {
        //Монипуляции с урлом нужны чтобы прошла перевалидация урла после смены статуса
        const tmp = this.url.value
        this.url.value = tmp + ' '
        this.$nextTick(() => {
          this.url.value = tmp
        })

        if (
          this.status.value &&
          (this.status.value.includes('Declined') ||
            this.status.value.includes('Recalled') ||
            this.status.value.includes('Failed'))
        ) {
          this.comments.required = true
          if (!this.comments.value) this.comments.isValid = false
        } else {
          this.comments.required = false
          this.comments.isValid = true
        }

        if (
          this.status.value &&
          (this.status.value.includes('Declined') ||
            this.status.value.includes('Failed'))
        ) {
          this.loss_reason.required = true
          this.loss_reason.readonly = false
          this.loss_reason.isValid = this.loss_reason.value?.length
            ? true
            : false
        } else {
          this.loss_reason.required = false
          this.loss_reason.readonly = true
          this.loss_reason.isValid = true
        }

        if (this.status.value && this.status.value.includes('Undefined')) {
          this.commercial_pages_link.isValid = true
          this.commercial_pages_link.required = false
        } else {
          this.commercial_pages_link.isValid =
            this.commercial_pages_link.value &&
            this.commercial_pages_link.value.length
              ? true
              : false
          this.commercial_pages_link.required = true
        }
      },
    },

    'client_id.value': {
      deep: true,
      handler() {
        this.client_name.value = this.client_id.value?.length
          ? this.client_id.dataList.find(
              (item) => item.id === this.client_id.value[0]
            ).name
          : null
      },
    },
  },

  methods: {
    setBoolValue(key, value) {
      this.$data[key].value = value
    },

    async fetchDataLinkReason() {
      let query = `page=1&per_page=all&reasons=asc`
      let result = await fetchData(urls.reasons, 'GET', null, query)

      this.loss_reason.dataList = (result?.rows || []).map((item) => {
        return {
          id: item.reasons,
          name: item.reasons,
        }
      })
    },

    // async fetchDataSlackCommunityStatus() {
    //   let query = `page=1&per_page=all&link_status=asc`
    //   let result = await fetchData(
    //     urls.slackCommunityStatus,
    //     'GET',
    //     null,
    //     query
    //   )

    //   this.slack_community_status.dataList = (result?.rows || []).map(
    //     (item) => {
    //       return {
    //         id: item.slack_community_status,
    //         name: item.slack_community_status,
    //       }
    //     }
    //   )
    // },

    async fetchDataLinkStatus() {
      let query = `page=1&per_page=all&link_status=asc`
      let result = await fetchData(urls.linkStatuses, 'GET', null, query)

      this.status.dataList = (result?.rows || []).map((item) => {
        return {
          id: item.link_status,
          name: item.link_status,
        }
      })
    },

    async fetchDataClients() {
      let query = '' //`page=1&per_page=all&client_name=asc`
      let result = await fetchData(urls.clientList, 'GET', null, query)

      this.client_id.dataList = (result?.rows || []).map((item) => {
        return {
          id: item.id,
          name: item.client_name,
        }
      })
    },

    cancel() {
      this.$emit('cancel')
    },

    save() {
      if (!this.url.isValid || !this.target_page.isValid) {
        this.textConfirmAlert = 'Enter a valid URL.'
        this.isVisibleConfirmAlert = true
        return
      }

      if (!this.isValidUrl('status', 'url')) {
        this.textConfirmAlert =
          'The link with status Pitched or Published should have at least 7 symbols after basic URL.'
        this.url.isValid = false
        this.isVisibleConfirmAlert = true
        return
      }

      if (!this.isValid) return

      this.$emit('save', this.rowForSave())
    },
  },
}
</script>
